module.exports = __webpack_public_path__ + "static/assets/ce7709857b5517cb82b97e2df96e7853.svg";